<h1 class="heading">Virtual Time Series Editor    <button (click)="delete()" *ngIf="virtualTimeSeries && virtualTimeSeries.id && (azureAuthService.isAdmin() || azureAuthService.isOwner())" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash"></i></button></h1>
<div *ngIf="virtualTimeSeries != null">
    <div class="row mt-2">
        <div class="col-6">
            <div class="form-group mb-3">
                <label class="form-label" for="virtualsite">Site</label>
                <select class="form-select" [(ngModel)]="virtualTimeSeries.siteUri">
                    <option value="">-- CLEAR --</option>
                    <option *ngFor="let site of sites" [value]="site.siteUri">
                        {{site.siteName}} -- {{site.siteDescription}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group mb-3">
                <label class="form-label" for="virtualName">Name</label>
                <input type="text" class="form-control" id="virtualName" placeholder="Virtual Name" [(ngModel)]="virtualTimeSeries.name" maxlength="100" [ngClass]="{'is-invalid':virtualTimeSeries.name == null || virtualTimeSeries.name == ''}">
            </div>
        </div>
        <div class="col-6">
            <div class="form-group mb-3">
                <label class="form-label" for="virtualDiscription">Description</label>
                <input type="text" class="form-control" id="virtualDiscription" placeholder="Virtual Description" maxlength="200" [(ngModel)]="virtualTimeSeries.description">
            </div>
        </div>
        <div class="col-6">
            <div class="form-group mb-3">
                <label class="form-label" for="expression">Expression</label>
                <div class="input-group flex-nowrap">
                    <input type="text" class="form-control" id="expression" placeholder="x * 2" [(ngModel)]="virtualTimeSeries.config.expression" maxlength="150" (keyup.enter)="findVariables()" [ngClass]="{'is-invalid':virtualTimeSeries.config.expression == null || virtualTimeSeries.config.expression == ''}">
                    <span class="input-group-text" (click)="findVariables()">Evaluate</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col">
            <div class="form-group mb-3">
                <label class="form-label" for="expression">Meta Tags</label>
                <div class="input-group input-group-sm rowitem-group">
                    <input name="name" type="text" class="form-control form-control-sm" placeholder="Name" [(ngModel)]="newMetaTag"/>
                    <input name="variable" type="text" class="form-control form-control-sm" placeholder="Value" [(ngModel)]="newMetaValue"/>
                    <button class="input-group-append btn btn-outline-theme" (click)="addNewMetaTag()">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
                <div class="input-group input-group-sm rowitem-group" *ngFor="let metaData of virtualTimeSeries.metaData | keyvalue">
                    <input name="name" type="text" class="form-control form-control-sm" placeholder="Name" [(ngModel)]="metaData.key"/>
                    <input name="variable" type="text" class="form-control form-control-sm" placeholder="Value" [(ngModel)]="metaData.value"/>
                    <button class="input-group-append btn btn-outline-theme" (click)="removeMetaTag(metaData.key)">
                        <i class="fa fa-remove"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="form-group mb-3">
                <label class="form-label" for="expression">Post Transform</label>
                <app-transform-editor [showTitle]="false" [transforms]="virtualTimeSeries.config.transforms"></app-transform-editor>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12">
            <h1 class="mb">Variables</h1>        
            <tabset>
                <tab [heading]="variable.key" *ngFor="let variable of virtualTimeSeries.config.variables | keyvalue">
                    <div class="row mt-2">
                        <!--<div class="col-6">
                            <div class="form-group mb-3">
                                <label class="form-label" for="virtualName">Name</label>
                                <input type="text" class="form-control" id="virtualName" readonly="true" placeholder="Parameter Name" [(ngModel)]="variable.value.name">
                            </div>
                        </div>-->
                        <div class="col-6">
                            <div class="form-group mb-3">
                                <label class="form-label" for="virtualName">Time Series</label>
                                <app-uri-select 
                                    [customerId]="virtualTimeSeries.customerId" 
                                    [timeSeriesDetail]="variable.value"     
                                    [enableMediaSearch]="false" 
                                    [enableMultiSelect]="true"
                                    [enableTagMatch]="true" 
                                    [siteTypeCode]="siteType.siteTypeCode"
                                    [siteUri]="virtualTimeSeries.siteUri"></app-uri-select>
                                <!--<app-time-series-select 
                                    [customerId]="virtualTimeSeries.customerId"
                                    [showVirtuals]="false"
                                    [enableTagMatch]="virtualTimeSeries.siteUri == null" 
                                    [timeSeriesDetail]="variable.value"></app-time-series-select>-->
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group mb-3">
                                <label class="form-label" for="expression">Pre Transform</label>
                                <app-transform-editor [showTitle]="false" [transforms]="variable.value.transforms"></app-transform-editor>
                            </div>
                        </div>
                    </div>
                    
                </tab>
            </tabset>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-6">
            <button class="btn btn-theme" *ngIf="azureAuthService.isAdmin() || azureAuthService.isOwner() || azureAuthService.isDashboardEditor()" [disabled]="!canSave()" (click)="save()">Save</button>
            <button class="btn btn-default" (click)="cancel()">Cancel</button>
        </div>
    </div>  
</div>
<ng-component *ngIf="virtualTimeSeries == null">
    No Virtual Time Series Selected
</ng-component>